"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

// This piece of code was orignally written by sindresorhus and can be seen here
// https://github.com/sindresorhus/lazy-value/blob/master/index.js

exports.default = function (fn) {
  var called = false;
  var ret = void 0;

  return function () {
    if (!called) {
      called = true;
      ret = fn();
    }

    return ret;
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/dist/utils/lazyValue.js
// module id = 1424
// module chunks = 28